// Dedicated role apps: the same codebase built once per role (VITE_APP_TYPE=driver|merchant|ops).
// Each app opens on its own start page, only serves the routes that make sense for that role, and
// is installable as its own home-screen app (manifest + title are generated at build time, see
// appTypePlugin in vite.config.js). Without VITE_APP_TYPE (the normal tukapp.co build) nothing
// here does anything. The backend still enforces roles: filtering routes is a convenience.

// pages every role app may open (info pages, QR links, payment returns, login callbacks)
const COMMON = ["/app-home", "/privacy", "/release_notes", "/cb", "/no_such_user", "/loading", "/install", "/qr", "/q", "/qrscanner", "/payment"];

export const APP_TYPES = {
  driver: {
    name: "TUK Driver",
    shortName: "Driver",
    description: "Jobs, map and wallet for TUK drivers",
    tagline: "Jobs, map and earnings",
    startRoute: "/driver-new",
    themeColor: "#ffbd20",
    backgroundColor: "#141218",
    icons: { small: "/img/icons/round-180x180.png", large: "/img/icons/round-512x512.png" },
    allow: [
      "/driver", "/driver-new", "/driver-wallet", "/driver-settings", "/driver_wallet", "/driver_route",
      "/dispatcher_fleet", "/dispatcher_jobs", "/fleet_dispatcher", "/tuktuk", "/tuktuk_dispatcher",
      "/logistics_fleet", "/logistics_jobs", "/logistics_order", "/delivery", "/batch",
      "/profile", "/commerce_order",
    ],
  },
  merchant: {
    name: "TUK Shop",
    shortName: "TUK Shop",
    description: "Orders, menu and settings for TUK shops",
    tagline: "Orders, menu and settings",
    startRoute: "/ecommerce",
    themeColor: "#1c1a22",
    backgroundColor: "#141218",
    icons: { small: "/img/icons/maskable/darkcircle192.png", large: "/img/icons/transparent-dark-512x512.png" },
    allow: [
      "/ecommerce", "/commerce_home", "/commerce_page", "/menu_editor", "/commerce_agent_order",
      "/commerce_order", "/commerce", "/business_login", "/business_profile", "/shop_signup",
      "/restaurant_signup", "/new_shop", "/shop_plans", "/shop_create", "/shop", "/invoice", "/profile",
    ],
  },
  ops: {
    name: "TUK Ops",
    shortName: "TUK Ops",
    description: "Operations console for TUK staff",
    tagline: "Operations console",
    startRoute: "/super_ops",
    themeColor: "#0b161e",
    backgroundColor: "#0b161e",
    icons: { small: "/img/icons/maskable/darkcircle192.png", large: "/img/icons/transparent-dark-512x512.png" },
    allow: [
      "/super_ops", "/user_lookup", "/user_info", "/control", "/fleet_dispatcher", "/dispatcher_fleet",
      "/dispatcher_jobs", "/list_editor", "/link_shortener", "/translator", "/driver_route", "/driver_wallet",
      "/driver-wallet", "/driver-settings", "/driver", "/driver-new", "/geometry", "/issues", "/batch", "/commerce_agent_order",
      "/commerce_order", "/business_profile", "/commerce_home", "/commerce_page", "/ecommerce", "/menu_editor",
      "/shop", "/orders", "/profile", "/logistics_fleet", "/logistics_jobs", "/logistics_order", "/delivery",
      "/invoice", "/user", "/search", "/eat", "/tuktuk",
    ],
  },
};

export const APP_TYPE = import.meta.env.VITE_APP_TYPE || null;
export const APP = APP_TYPE ? APP_TYPES[APP_TYPE] || null : null;

function allowed(path) {
  return COMMON.concat(APP.allow).some((p) => path === p || path.startsWith(p + "/"));
}

// Router guard for role apps: where should this navigation really go? (null = as asked)
export function appRedirect(to, loggedIn) {
  if (!APP) return null;
  // ?app=full switches the filter off for this visit (debugging / support)
  if (to.query && to.query.app === "full") return null;
  var path = to.path;
  var entry = path === "/" || path === "/home" || path === "/biz" || path === "/splash";
  if (entry || !allowed(path)) return { path: loggedIn ? APP.startRoute : "/app-home", replace: true };
  // logged out: the landing/login page, never a role page that would say "not allowed"
  if (!loggedIn && path !== "/app-home" && !COMMON.some((p) => path === p || path.startsWith(p + "/"))) {
    return { path: "/app-home", replace: true };
  }
  return null;
}
